import Items from '#src/client/common/layout/Items.jsx';
import Label from '#src/client/common/elements/Label.jsx';
import { splitProps } from 'solid-js';
import isEmpty from '#src/client/common/utils/isEmpty.js';

function LabeledItem(props) {
    const [local, others] = splitProps(props, [
        'size',
    ]);

    return (
        <Items {...others} size={local.size ?? 'small'}>
            <Show when={!isEmpty(props.label)}>
                <Label>{props.label}</Label>
            </Show>
            <div>{props.children}</div>
        </Items>
    );
}

export default LabeledItem;